<wm-common-overlay-modal
  class="contained-overlay"
  [isOpen]="true"
  [headerTitle]="'Workflow Template Library'"
  maxWidth="100%"
  [height]="'100%'"
  (closed)="close()"
  >
    <div class="content-wrapper">
      <wm-common-text class="section-title" [data]="{ text: 'Workflow Template Library' }"></wm-common-text>

      <div class="row title-margin">
        <div class="col">
          <wm-common-textfield
            [(ngModel)]="name" [data]="{ label: 'Workflow Name', placeholder: 'Workflow Name' }">
          </wm-common-textfield>
        </div>

        <div class="col">
          <wm-common-textfield
            [(ngModel)]="tags" [data]="{ label: 'Tags (comma separated)', placeholder: 'Tags (comma separated)' }">
          </wm-common-textfield>
        </div>
      </div>

      <div class="use-template-search-btn">
        <wm-common-button
          (click)="search()" [data]="{text: 'SEARCH' }">
        </wm-common-button>
      </div>

      <wm-common-table
        tableType="Staff"
        [columns]="columns"
        [data]="tableData"
        [isLoading]="isLoading">
      </wm-common-table>

    </div>
</wm-common-overlay-modal>
